"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const PrismicError = require("./errors/PrismicError.cjs");
const isRepositoryName = require("./isRepositoryName.cjs");
const getRepositoryEndpoint = (repositoryName) => {
  if (isRepositoryName.isRepositoryName(repositoryName)) {
    return `https://${repositoryName}.cdn.prismic.io/api/v2`;
  } else {
    throw new PrismicError.PrismicError(`An invalid Prismic repository name was given: ${repositoryName}`, void 0, void 0);
  }
};
exports.getRepositoryEndpoint = getRepositoryEndpoint;
//# sourceMappingURL=getRepositoryEndpoint.cjs.map
